export default __webpack_public_path__ + "static/media/progess-cir-bar-icon.da7ef245.svg";